// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"cart-item_cart-item__Fy_j7","img":"cart-item_img__3HP3Z","item-details":"cart-item_item-details__qhRil","name":"cart-item_name__3fVAY","price":"cart-item_price__3echv"};